// cat. resources - images (webpack asset pipeline: static/media/[name].[hash].svg)
// error
import ERROR_FORBIDDEN from 'assets/images/error/forbidden.svg';

// common modal
import COMMON_MODAL_ERROR from 'assets/images/common/modal/base_error.svg';
import COMMON_MODAL_WARNING from 'assets/images/common/modal/base_warning.svg';
import COMMON_MODAL_LOADING from 'assets/images/common/modal/base_loading.svg';

// common icon
import COMMON_ICON_ARROW_UP_FONT6 from 'assets/images/common/icon/arrow_up_font6.svg';
import COMMON_ICON_UPDATE_FONT2 from 'assets/images/common/icon/update_font2.svg';
import COMMON_ICON_DELETE_FONT6 from 'assets/images/common/icon/delete_font6.svg';
import COMMON_ICON_PLUS_PRIMARY from 'assets/images/common/icon/plus_primary.svg';
import COMMON_ICON_PLUS_WHITE from 'assets/images/common/icon/plus_white.svg';
import COMMON_ICON_MINUS_FONT6 from 'assets/images/common/icon/minus_font6.svg';
import COMMON_ICON_LINK_GREEN from 'assets/images/common/icon/link_green.svg';
import COMMON_ICON_VIEW_PRIMARY from 'assets/images/common/icon/view_primary.svg';
import COMMON_ICON_RESET_FONT6 from 'assets/images/common/icon/reset_font6.svg';
import COMMON_ICON_CALENDAR_FONT2 from 'assets/images/common/icon/calendar_font2.svg';
import COMMON_ICON_CALENDAR_PRIMARY from 'assets/images/common/icon/calendar_primary.svg';
import COMMON_ICON_COPY_FONT7 from 'assets/images/common/icon/copy_font7.svg';
import COMMON_ICON_UPLOAD_PRIMARY from 'assets/images/common/icon/upload_primary.svg';

// menu
import APP_MENU_DASHBOARD from 'assets/images/menu/dashboard.svg';
import APP_MENU_ACTIVE_DASHBOARD from 'assets/images/menu/active/dashboard.svg';
import APP_MENU_MEMBER from 'assets/images/menu/member.svg';
import APP_MENU_ACTIVE_MEMBER from 'assets/images/menu/active/member.svg';
import APP_MENU_DOCUMENT from 'assets/images/menu/document.svg';
import APP_MENU_ACTIVE_DOCUMENT from 'assets/images/menu/active/document.svg';
import APP_MENU_WATERMARK from 'assets/images/menu/watermark.svg';
import APP_MENU_ACTIVE_WATERMARK from 'assets/images/menu/active/watermark.svg';
import APP_MENU_VIEW_CONFIG from 'assets/images/menu/view_config.svg';
import APP_MENU_ACTIVE_VIEW_CONFIG from 'assets/images/menu/active/view_config.svg';
import APP_MENU_VIEWER from 'assets/images/menu/web_viewer.svg';
import APP_MENU_ACTIVE_VIEWER from 'assets/images/menu/active/web_viewer.svg';
import APP_MENU_SYSTEM_LOG from 'assets/images/menu/system_log.svg';
import APP_MENU_ACTIVE_SYSTEM_LOG from 'assets/images/menu/active/system_log.svg';
import APP_MENU_SYSTEM_CONFIG from 'assets/images/menu/system_config.svg';
import APP_MENU_ACTIVE_SYSTEM_CONFIG from 'assets/images/menu/active/system_config.svg';
import APP_MENU_INTO_SYSTEM_CONFIG from 'assets/images/menu/into_system_config.svg';
import APP_MENU_ACTIVE_INTO_SYSTEM_CONFIG from 'assets/images/menu/active/into_system_config.svg';

// app page
import PAGE_BASE_MENU_EXPAND from 'assets/images/page/base/menu_expand.svg';
import PAGE_BASE_MENU_COLLAPSE from 'assets/images/page/base/menu_collapse.svg';
import PAGE_BASE_DEFAULT_USER from 'assets/images/page/base/default_member.svg';
import PAGE_MODAL_LOGOUT from 'assets/images/page/base/modal_logout.svg';

import PAGE_DASHBOARD_WEB_VIEWER from 'assets/images/page/dashboard/web_viewer.svg';
import PAGE_DASHBOARD_WEB_VIEWER_EXPIRED from 'assets/images/page/dashboard/web_viewer_expired.svg';
import PAGE_DASHBOARD_WATERMARK from 'assets/images/page/dashboard/watermark.svg';
import PAGE_DASHBOARD_VIEW_CONFIG from 'assets/images/page/dashboard/view_config.svg';

import PAGE_DASHBOARD_ICON_UPLOAD_FOLDER from 'assets/images/page/dashboard/icon_upload_folder.svg';
import PAGE_MEMBER_MODAL_DELETE from 'assets/images/page/member/modal_delete.svg';
import PAGE_DOCUMENT_MODAL_DELETE from 'assets/images/page/document/modal_delete.svg';
import PAGE_VIEW_CONFIG_MODAL_DELETE from 'assets/images/page/view_config/modal_delete.svg';
import PAGE_VIEW_CONFIG_BUTTON_INIT from 'assets/images/page/view_config/button_init.svg';

import PAGE_WATERMARK_ICON_TEXT from 'assets/images/page/watermark/icon_text.svg';
import PAGE_WATERMARK_ICON_IMAGE from 'assets/images/page/watermark/icon_image.svg';
import PAGE_WATERMARK_ICON_TEXT_PRIMARY from 'assets/images/page/watermark/icon_text_primary.svg';
import PAGE_WATERMARK_ICON_IMAGE_PRIMARY from 'assets/images/page/watermark/icon_image_primary.svg';
import PAGE_WATERMARK_ICON_SYNC from 'assets/images/page/watermark/icon_sync.svg';
import PAGE_WATERMARK_ICON_REMOVE from 'assets/images/page/watermark/icon_remove.svg';
import PAGE_WATERMARK_MODAL_DELETE from 'assets/images/page/watermark/modal_delete.svg';

import PAGE_VIEWER_ICON_VIEW from 'assets/images/page/viewer/icon_view.svg';
import PAGE_VIEWER_ICON_PRINT from 'assets/images/page/viewer/icon_print.svg';
import PAGE_VIEWER_ICON_DOWNLOAD from 'assets/images/page/viewer/icon_download.svg';
import PAGE_VIEWER_MODAL_DELETE from 'assets/images/page/viewer/modal_delete.svg';
import PAGE_VIEWER_ICON_FILE_UPLOAD_CHECK from 'assets/images/page/viewer/modal_form_upload_check.svg';
import PAGE_SETTINGS_ICON_HIDDEN from 'assets/images/page/settings/icon_hidden.svg';


class Option {
    constructor() {
        this._apiPath = "/";
        this._contextPath = "/";
        this._resourcePath = "/";

        // init 설정
        const _contextPathEl = document.getElementById("context-path");
        if (_contextPathEl) {
            const href = _contextPathEl.getAttribute("href");
            const normalizedHref = href ? (href.endsWith('/') ? href : href + '/') : "/";
            this._contextPath = normalizedHref;
            this._apiPath = normalizedHref;
            this._resourcePath = normalizedHref;

            window.option = this;
        }

        this._domainPath = window.INTO_DOMAIN || `${window.location.protocol}//${window.location.host}${this._contextPath || "/"}`;
        this._hostView = this._domainPath + "view";
    }

    get API_PATH() {
        return this._apiPath;
    }

    get CONTEXT_PATH() {
        return this._contextPath;
    }

    get RESOURCE_PATH() {
        return this._resourcePath;
    }

    get HOST_VIEW() {
        return this._hostView;
    }

    get REST_API_URL() {
        return {
            SYSTEM: this.API_PATH + "v1/internal/system",
            LOG: this.API_PATH + "v1/internal/log",
            MEMBER_TOKEN: this.API_PATH + "v1/internal/member/token",
            MEMBER: this.API_PATH + "v1/internal/member",
            DOCUMENT: this.API_PATH + "v1/internal/document",
            VIEW_CONFIG: this.API_PATH + "v1/internal/view-config",
            WATERMARK: this.API_PATH + "v1/internal/watermark",
            VIEWER: this.API_PATH + "v1/internal/viewer",
            VIEW: this.API_PATH + "v1/view",
        }
    }

    get REST_API_ACTION() {
        return {
            COUNT: "count",
            STATISTIC: "statistic",
            LIST: "list",
            SEARCH: "search",
            CREATE: "create",
            UPDATE: "update",
            DELETE: "delete",
            BATCH_CREATE: "batch-create",
            BATCH_UPDATE: "batch-update",
            BATCH_DELETE: "batch-delete",
            PRINT: "print",
            DOWNLOAD: "download",
            UPLOAD: "upload",
            RECONVERT: "reconvert",
            CONVERT_ASYNC: "async-convert",
        }
    }

    get REST_API() {
        const URL = this.REST_API_URL;
        const ACTION = this.REST_API_ACTION;
        return {
            SYSTEM: {
                LIST_CONFIG: {URL: `${URL.SYSTEM}/config`, METHOD: "GET"},
                BATCH_UPDATE_CONFIG: {URL: `${URL.SYSTEM}/config/batch`, METHOD: "PUT"},
            },
            LOG: {
                LIST: {URL: `${URL.LOG}`, METHOD: "GET"},
                DOWNLOAD: {URL: `${URL.LOG}/download`, METHOD: "GET"},
            },
            MEMBER_TOKEN: {
                CREATE: {URL: `${URL.MEMBER_TOKEN}`, METHOD: "POST"},
                DELETE: {URL: `${URL.MEMBER_TOKEN}`, METHOD: "DELETE"},
            },
            MEMBER: {
                COUNT: {URL: `${URL.MEMBER}/${ACTION.COUNT}`, METHOD: "GET"},
                SEARCH: {URL: `${URL.MEMBER}/${ACTION.SEARCH}`, METHOD: "GET"},
                INFO: {URL: `${URL.MEMBER}/{0}`, METHOD: "GET"},
                CREATE: {URL: `${URL.MEMBER}`, METHOD: "POST"},
                UPDATE: {URL: `${URL.MEMBER}/{0}`, METHOD: "PUT"},
                DELETE: {URL: `${URL.MEMBER}/{0}`, METHOD: "DELETE"},
                BATCH_DELETE: {URL: `${URL.MEMBER}/${ACTION.BATCH_DELETE}`, METHOD: "DELETE"},
            },
            DOCUMENT: {
                CONVERT_ASYNC: {URL: `${URL.DOCUMENT}/{0}/${ACTION.CONVERT_ASYNC}`, METHOD: "POST"},
            },
            VIEW_CONFIG: {
                COUNT: {URL: `${URL.VIEW_CONFIG}/${ACTION.COUNT}`, METHOD: "GET"},
                SEARCH: {URL: `${URL.VIEW_CONFIG}/${ACTION.SEARCH}`, METHOD: "GET"},
                INFO: {URL: `${URL.VIEW_CONFIG}/{0}`, METHOD: "GET"},
                CREATE: {URL: `${URL.VIEW_CONFIG}`, METHOD: "POST"},
                UPDATE: {URL: `${URL.VIEW_CONFIG}/{0}`, METHOD: "PUT"},
                DELETE: {URL: `${URL.VIEW_CONFIG}/{0}`, METHOD: "DELETE"},
                BATCH_DELETE: {URL: `${URL.VIEW_CONFIG}/${ACTION.BATCH_DELETE}`, METHOD: "DELETE"},
            },
            WATERMARK: {
                COUNT: {URL: `${URL.WATERMARK}/${ACTION.COUNT}`, METHOD: "GET"},
                SEARCH: {URL: `${URL.WATERMARK}/${ACTION.SEARCH}`, METHOD: "GET"},
                INFO: {URL: `${URL.WATERMARK}/{0}`, METHOD: "GET"},
                CREATE: {URL: `${URL.WATERMARK}`, METHOD: "POST"},
                UPDATE: {URL: `${URL.WATERMARK}/{0}`, METHOD: "PUT"},
                DELETE: {URL: `${URL.WATERMARK}/{0}`, METHOD: "DELETE"},
                BATCH_DELETE: {URL: `${URL.WATERMARK}/${ACTION.BATCH_DELETE}`, METHOD: "DELETE"},
            },
            VIEWER: {
                COUNT: {URL: `${URL.VIEWER}/${ACTION.COUNT}`, METHOD: "GET"},
                SEARCH: {URL: `${URL.VIEWER}/${ACTION.SEARCH}`, METHOD: "GET"},
                INFO: {URL: `${URL.VIEWER}/{0}`, METHOD: "GET"},
                CREATE: {URL: `${URL.VIEWER}`, METHOD: "POST"},
                UPDATE: {URL: `${URL.VIEWER}/{0}`, METHOD: "PUT"},
                DELETE: {URL: `${URL.VIEWER}/{0}`, METHOD: "DELETE"},
                BATCH_DELETE: {URL: `${URL.VIEWER}/${ACTION.BATCH_DELETE}`, METHOD: "DELETE"},
                STATISTIC_ACTION: {URL: `${URL.VIEWER}/${ACTION.STATISTIC}/{0}`, METHOD: "GET"},
            },
            VIEW: {
                INFO: {URL: `${URL.VIEW}/{0}`, METHOD: "GET"},
                ACTION_HIT: {URL: `${URL.VIEW}/{0}/hit`, METHOD: "POST"},
                PRINT: {URL: `${URL.VIEW}/{0}/${ACTION.PRINT}`, METHOD: "POST"},
                DOWNLOAD: {URL: `${URL.VIEW}/{0}/${ACTION.DOWNLOAD}`, METHOD: "GET"},
                DOWNLOAD_DOCUMENT_RESOURCE_FILE: {URL: `${URL.VIEW}/{0}/document/{1}/resource-file`, METHOD: "GET"},
                INFO_DOCUMENT: {URL: `${URL.VIEW}/{0}/document/{1}`, METHOD: "GET"},
                CONVERT_DOCUMENT_ASYNC: {URL: `${URL.VIEW}/{0}/document/{1}/${ACTION.CONVERT_ASYNC}`, METHOD: "POST"},
            },
            INTERNAL: {
                MEMBER: {
                    INFO: {URL: `${URL.MEMBER}/{0}`, METHOD: "GET"},
                    UPDATE: {URL: `${URL.MEMBER}/{0}`, METHOD: "PUT", REQUIRE: ["password"]},
                },
                WATERMARK: {
                    INFO: {URL: `${URL.WATERMARK}/{0}`, METHOD: "GET"},
                },
            },
        };
    }

    get ROUTE_PATH() {
        return {
            ROOT: this.CONTEXT_PATH,
            SIGN_IN: this.CONTEXT_PATH + "signin",
            // page - app
            DASHBOARD: this.CONTEXT_PATH + "dashboard",
            MEMBER: this.CONTEXT_PATH + "member",
            DOCUMENT: this.CONTEXT_PATH + "document",
            WATERMARK: this.CONTEXT_PATH + "watermark",
            VIEW_CONFIG: this.CONTEXT_PATH + "view_config",
            VIEWER: this.CONTEXT_PATH + "viewer",
            SYSTEM_LOG: this.CONTEXT_PATH + "system_log",
            SYSTEM_CONFIG: this.CONTEXT_PATH + "system_config",
            INTO_SYSTEM_CONFIG: this.CONTEXT_PATH + "into_system_config",
            // page - view
            VIEW: this.CONTEXT_PATH + "view",
        };
    }

    get ROUTE_PATH_GROUP() {
        return {
            [this.ROUTE_PATH.INTO_SYSTEM_CONFIG]: [
                this.ROUTE_PATH.INTO_SYSTEM_CONFIG,
                this.ROUTE_PATH.INTO_SYSTEM_CONFIG + "/BASE",
                this.ROUTE_PATH.INTO_SYSTEM_CONFIG + "/PRODUCT",
                this.ROUTE_PATH.INTO_SYSTEM_CONFIG + "/VIEWER",
            ],
        };
    }

    // cat. resources
    get INTO_RESOURCES() {
        return {
            IMAGES: {
                // error
                ERROR_FORBIDDEN,

                // common modal
                COMMON_MODAL_ERROR,
                COMMON_MODAL_WARNING,
                COMMON_MODAL_LOADING,

                // common icon
                COMMON_ICON_ARROW_UP_FONT6,
                COMMON_ICON_UPDATE_FONT2,
                COMMON_ICON_DELETE_FONT6,
                COMMON_ICON_PLUS_PRIMARY,
                COMMON_ICON_PLUS_WHITE,
                COMMON_ICON_MINUS_FONT6,
                COMMON_ICON_LINK_GREEN,
                COMMON_ICON_VIEW_PRIMARY,
                COMMON_ICON_RESET_FONT6,
                COMMON_ICON_CALENDAR_FONT2,
                COMMON_ICON_CALENDAR_PRIMARY,
                COMMON_ICON_COPY_FONT7,
                COMMON_ICON_UPLOAD_PRIMARY,

                // menu
                APP_MENU_DASHBOARD,
                APP_MENU_ACTIVE_DASHBOARD,
                APP_MENU_MEMBER,
                APP_MENU_ACTIVE_MEMBER,
                APP_MENU_DOCUMENT,
                APP_MENU_ACTIVE_DOCUMENT,
                APP_MENU_WATERMARK,
                APP_MENU_ACTIVE_WATERMARK,
                APP_MENU_VIEW_CONFIG,
                APP_MENU_ACTIVE_VIEW_CONFIG,
                APP_MENU_VIEWER,
                APP_MENU_ACTIVE_VIEWER,
                APP_MENU_SYSTEM_LOG,
                APP_MENU_ACTIVE_SYSTEM_LOG,
                APP_MENU_SYSTEM_CONFIG,
                APP_MENU_ACTIVE_SYSTEM_CONFIG,
                APP_MENU_INTO_SYSTEM_CONFIG,
                APP_MENU_ACTIVE_INTO_SYSTEM_CONFIG,

                // app page
                PAGE_BASE_MENU_EXPAND,
                PAGE_BASE_MENU_COLLAPSE,
                PAGE_BASE_DEFAULT_USER,
                PAGE_MODAL_LOGOUT,

                PAGE_DASHBOARD_WEB_VIEWER,
                PAGE_DASHBOARD_WEB_VIEWER_EXPIRED,
                PAGE_DASHBOARD_WATERMARK,
                PAGE_DASHBOARD_VIEW_CONFIG,

                PAGE_DASHBOARD_ICON_UPLOAD_FOLDER,
                PAGE_MEMBER_MODAL_DELETE,
                PAGE_DOCUMENT_MODAL_DELETE,
                PAGE_VIEW_CONFIG_MODAL_DELETE,
                PAGE_VIEW_CONFIG_BUTTON_INIT,

                PAGE_WATERMARK_ICON_TEXT,
                PAGE_WATERMARK_ICON_IMAGE,
                PAGE_WATERMARK_ICON_TEXT_PRIMARY,
                PAGE_WATERMARK_ICON_IMAGE_PRIMARY,
                PAGE_WATERMARK_ICON_SYNC,
                PAGE_WATERMARK_ICON_REMOVE,
                PAGE_WATERMARK_MODAL_DELETE,

                PAGE_VIEWER_ICON_VIEW,
                PAGE_VIEWER_ICON_PRINT,
                PAGE_VIEWER_ICON_DOWNLOAD,
                PAGE_VIEWER_MODAL_DELETE,
                PAGE_VIEWER_ICON_FILE_UPLOAD_CHECK,
                PAGE_SETTINGS_ICON_HIDDEN,
            },
            FILES: {
                SAMPLE_PDF: this.RESOURCE_PATH + "sample/sample.pdf",
                PRINT_MODULE_INSTALLER: this.RESOURCE_PATH + "print-module/print-module-setup.exe",
            }
        }
    }

    get INTO_IMAGE() {
        return this.INTO_RESOURCES.IMAGES;
    }

    get INTO_FILE() {
        return this.INTO_RESOURCES.FILES;
    }

    get DOMAIN() {
        return {};
    }
}

const OptionSingleton = (() => {
    let instance = null;
    return {
        getInstance: function () {
            if (!instance) {
                instance = new Option()
            }
            return instance;
        }
    }
})();

export default OptionSingleton.getInstance();